// extracted by mini-css-extract-plugin
export default {"backdrop":"Sound_backdrop__yR7ol","agree":"Sound_agree__478AD"};